import React, { useState, useEffect } from 'react';
import { Subscription, Query } from 'react-apollo';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { GET_ALL_SMS_CONVO, GET_MY_SMS_CONVOS } from 'graphql/conversations';
import Spin from 'components/common/Spin';
import UsersList from './UsersList';
import ConvoRoom from './ConvoRoom';
import { Box, Card, CardHeader, makeStyles } from '@material-ui/core';
import SearchBox from '../chat/components/SearchBox';
import {ROLES} from "../../../../constant/userTypes";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles((theme) => ({
  avatar: {},
  cardAction: {
    fontSize: 14,
  },
}));

const SMSScreen = ({ match: { params } }) => {
  const classes = useStyles();
  const [allChannels, setAllChannels] = useState(false);
  const [unreadOnly, setUnreadOnly] = useState(true);
  const user = useSelector((s) => s.user.user);
  const [query, setQuery] = useState('');

  return (
    <div>
      <Helmet title="Text Messages" />
      <Grid container spacing={3}>
        <Grid item md={4}>
          <Card>
            <Box display="flex" padding={1} justifyContent="center">
              {user.type === ROLES.ADMIN && (
                <FormControlLabel
                  value={true}
                  checked={allChannels}
                  onChange={(e) => setAllChannels(e.target.checked)}
                  control={<Switch size="small" color="primary" />}
                  label="Show all users"
                  labelPlacement="end"
                  classes={{
                    label: classes.cardAction,
                  }}
                />
              )}
              <FormControlLabel
                value={true}
                checked={unreadOnly}
                onChange={(e) => setUnreadOnly(e.target.checked)}
                control={<Switch size="small" color="primary" />}
                label="Show unread only"
                labelPlacement="end"
                classes={{
                  label: classes.cardAction,
                }}
              />
            </Box>
            <Box paddingLeft={2} paddingRight={2}>
              <SearchBox onSearch={setQuery} />
            </Box>
            { allChannels ? (
                <Query query={GET_ALL_SMS_CONVO} variables={{ query: query ? `%${query}%` : undefined }}>
                  {({ data, loading }) => {
                    if (loading) return <Spin spinning />;
                    return (
                        <UsersList
                            users={data.rows}
                            selected={params.convoId}
                        />
                    );
                  }}
                </Query>
            ) : (
                <Subscription
                    subscription={GET_MY_SMS_CONVOS}
                    variables={{
                      userId: user.id,
                      query: query ? `%${query}%` : undefined,
                      unread: unreadOnly === true ? unreadOnly : undefined,
                    }}
                >
                  {({ data, loading, error }) => {
                    if (loading) return <Spin spinning />;

                    if (error) return error.message;

                    return (
                        <UsersList
                            users={data.rows}
                            selected={params.convoId}
                        />
                    );
                  }}
                </Subscription>
            )}

          </Card>
        </Grid>
        <Grid item md={8}>
          <Box marginBottom={{ xs: 14, sm: 0 }}>
            <Route path="/inbox/sms/:convoId" component={ConvoRoom} />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default SMSScreen;
